module.exports = __webpack_public_path__ + "static/media/won-sign.ebeea8d5.svg";